export default __webpack_public_path__ + "static/media/user_info_image.f328c390.png";